var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTramway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Temps_d_x27_attente"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ardoise"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Logos"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M160,80.205C160,35.801,124.204,0,79.803,0C35.602,0,0,35.801,0,80.205C0,124.406,35.602,160,79.803,160 C124.204,160,160,124.406,160,80.205z M148.199,80.205c0,37.592-30.596,67.996-68.396,67.996c-37.602,0-68-30.404-68-67.996 c0-37.803,30.398-68.404,68-68.404C117.603,11.801,148.199,42.402,148.199,80.205z M117.406,48.404 c0-3.201-2.003-6.201-5.604-6.201H48.403c-3.599,0-5.604,3-5.604,6.201c0,2.799,2.005,6.199,5.604,6.199h24.401v65.6 c0,3.596,3.804,5.6,7.195,5.6c3.8,0,7.407-2.004,7.407-5.6v-65.6h24.396C115.402,54.604,117.406,51.203,117.406,48.404z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTramway);
export default __webpack_public_path__ + "static/media/Tramway.edd14d1ba467ac8e0c98821fabca477a.svg";
export { ForwardRef as ReactComponent };